import React from 'react';
import { Heart, Share2, UserPlus } from 'lucide-react';

const SOCIALS = [
  { name: 'Instagram', href: 'https://www.instagram.com/motion.reality/' },
  { name: 'TikTok', href: 'https://www.tiktok.com/@motionrealitysimracing' },
  { name: 'YouTube', href: 'https://www.youtube.com/@MotionRealityRacing' },
];

// Shared "boost your entry" block: asks entrants to like, share and follow our
// social posts, and optionally collects their social handles. Used by both the
// free monthly entry form and the paid sim-rig entry form.
export default function SocialEngagementBlock({ form, setForm }) {
  const toggle = (key) => setForm((f) => ({ ...f, [key]: !f[key] }));
  const setField = (key, val) => setForm((f) => ({ ...f, [key]: val }));

  return (
    <div className="border border-primary/20 bg-primary/[0.03] p-4 mt-5">
      <p className="text-primary text-[10px] font-bold tracking-widest mb-1">BOOST YOUR ENTRY (OPTIONAL)</p>
      <p className="text-white/40 text-[11px] leading-relaxed mb-3">
        Help us reach more racers — like, share and follow our social posts. It's not required to enter, but every bit
        helps us grow the community and future prize funds.
      </p>
      <div className="space-y-2.5">
        <label className="flex items-center gap-3 cursor-pointer">
          <input type="checkbox" checked={!!form.liked_post} onChange={() => toggle('liked_post')} className="accent-[#e11d2a]" />
          <Heart className="w-4 h-4 text-primary/60 shrink-0" />
          <span className="text-white/70 text-xs flex-1">I've liked our latest Instagram post</span>
          <a href="https://www.instagram.com/motion.reality/" target="_blank" rel="noreferrer" className="text-primary text-[10px] font-bold tracking-widest underline shrink-0">OPEN</a>
        </label>
        <label className="flex items-center gap-3 cursor-pointer">
          <input type="checkbox" checked={!!form.shared_post} onChange={() => toggle('shared_post')} className="accent-[#e11d2a]" />
          <Share2 className="w-4 h-4 text-primary/60 shrink-0" />
          <span className="text-white/70 text-xs flex-1">I've shared the competition post</span>
          <a href="https://www.instagram.com/motion.reality/" target="_blank" rel="noreferrer" className="text-primary text-[10px] font-bold tracking-widest underline shrink-0">OPEN</a>
        </label>
        <label className="flex items-center gap-3 cursor-pointer">
          <input type="checkbox" checked={!!form.followed_social} onChange={() => toggle('followed_social')} className="accent-[#e11d2a]" />
          <UserPlus className="w-4 h-4 text-primary/60 shrink-0" />
          <span className="text-white/70 text-xs flex-1">I'm following Motion Reality</span>
          <div className="flex gap-2 shrink-0">
            {SOCIALS.map((s) => (
              <a key={s.name} href={s.href} target="_blank" rel="noreferrer" className="text-primary text-[10px] font-bold tracking-widest underline">{s.name.toUpperCase()}</a>
            ))}
          </div>
        </label>
      </div>
      <div className="grid sm:grid-cols-3 gap-3 mt-4">
        {[
          ['instagram_handle', 'INSTAGRAM HANDLE'],
          ['facebook_handle', 'FACEBOOK NAME'],
          ['tiktok_handle', 'TIKTOK HANDLE'],
        ].map(([k, l]) => (
          <div key={k}>
            <label className="text-white/30 text-[9px] font-bold tracking-widest mb-1 block">{l}</label>
            <input value={form[k] || ''} onChange={(e) => setField(k, e.target.value)} className="seo-input" placeholder="@yourhandle" />
          </div>
        ))}
      </div>
    </div>
  );
}